import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import EditEmployee from "../../Forms/EditEmployee";
import axios from "axios";
import toastr from "toastr";
import RaisedButton from "material-ui/RaisedButton";
import moment from "moment";
import EmployeePersonalEdit from "../../Forms/EmployeePersonalEdit";


function modifyDates(employee) {
  let emp = new Object();
  emp = employee;
  if (emp['empDOB'] != null) {
    emp['empDOB'] = new Date(emp['empDOB']);
  }
  let fields = ['empAnniversary', 'spouseDOB', 'child1DOB', 'child2DOB']
  fields.map((node)=> {
    let date = moment(employee[node], "DD-MM-YYYY");
    if (moment(date).isValid()) {
      emp[node] = new Date(date);
    }
  });
  return emp;

}


class Modals extends React.Component {

  constructor(props) {
    super(props);
    this.state = {reportingManager: null, professional: true, personal: false, employeePersonal: {}, initial: {}}

    this.getRequestObject = this.getRequestObject.bind(this);
    this.editEmployee = this.editEmployee.bind(this);
    this.submitPersonalInfo = this.submitPersonalInfo.bind(this);
  }

  getRequestObject(data) {
    data.id = null;
    data.empId = this.props.employee.employeeCode;
    data.name = this.props.employee.name;
    data.doResignation = data.doResignation.getTime();
    data.doLeaving = data.doLeaving.getTime();
    data.remarks = data.remarks ? data.remarks : null;
    return data;
  }

  submitPersonalInfo(data) {
    let request = Object.assign({}, data);
    if (request['empAnniversary'] != null)
      request['empAnniversary'] = request['empAnniversary'].toLocaleDateString('en-GB');
    if (request['empDOB'] != null)
      request['empDOB'] = request['empDOB'].getTime();
    axios.post(process.env.REQ_URL + "/edit/personal", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      axios.post(process.env.REQ_URL + "/edit/contact", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        axios.get(process.env.REQ_URL + "/personal?q=" + this.props.employee.employeeCode, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
          let employee = Object.assign({}, response.data.data);
          employee = modifyDates(employee);
          this.setState({employee: response.data.data, initial: employee})
          toastr.success("Data updated");
          this.props.close();
        }).catch((error) => {
          console.log(error);
        });
      }).catch((error)=> {
        console.log(error);
      });
    }).catch((error) => {
      toastr.error("Error Occurred");
    });


  }

  editEmployee(data, reportingTo, verticalHead) {
    console.log(request);
    let request = Object.assign({}, data);
    request.reportingTo = reportingTo;
    request.verticalHead = verticalHead;

    request.empId = this.props.employee.employeeCode;
    if (request.dateOfJoining != null) {
      request.dateOfJoining = request.dateOfJoining.getTime();
    }

    axios.post(process.env.REQ_URL + "/editProfile", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.props.close();
      toastr.success(response.data.data);
      this.props.refresh(request.empId);
    }).catch((err)=> {
      toastr.error("Error Occurred");

    });


    console.log(request);
  }

  componentDidMount() {
    axios.get(process.env.REQ_URL + "/personal?q=" + this.props.employee.employeeCode, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employee = Object.assign({}, response.data.data);
      employee = modifyDates(employee);
      this.setState({employeePersonal: response.data.data, initial: employee})

    }).catch((error) => {
      console.log(error);
    });
  }

  render() {
    let employee = Object.assign({}, this.props.employee);
    if (employee.dateOfJoining != null)
      employee.dateOfJoining = new Date(employee.dateOfJoining);
    const initialValues = {
      initialValues: employee
    };
    const personalInitialValues = {
      initialValues: this.state.initial
    }

    return (
      <Modal
        bsSize="lg"
        show={this.props.open} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>
            <RaisedButton
              onClick={()=> {
                if (!this.state.professional) {
                  this.setState({professional: true, personal: false});
                }

              }}
              label="Edit Professional Details" secondary={this.state.professional}/>&nbsp;&nbsp;
            <RaisedButton
              onClick={()=> {
                if (!this.state.personal)
                  this.setState({professional: false, personal: true})
              }}
              label="Edit Personal Details" secondary={this.state.personal}/>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.professional ? <EditEmployee
            close={this.props.close}
            edit={this.editEmployee}
            employees={this.props.employees}
            constants={this.props.constants}
            {...initialValues}
            employee={this.props.employee}
            applyExit={this.applyExit}
          /> : null}
          {this.state.personal ?
            <EmployeePersonalEdit
              admin={true}
              submitHandler={this.submitPersonalInfo}
              close={this.props.close}
              {...personalInitialValues}
              employee={this.state.employeePersonal}/> : null}
          &nbsp;

        </Modal.Body>
      </Modal>
    );
  }
}

Modals.propTypes = {};

export default Modals;





/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/PeopleSearch/components/ModalEdit.js
 **/